export default __webpack_public_path__ + "static/media/1.62c42d2c.jpg";